import { render, staticRenderFns } from "./AudioBar.vue?vue&type=template&id=c85a507c&"
import script from "./AudioBar.vue?vue&type=script&lang=js&"
export * from "./AudioBar.vue?vue&type=script&lang=js&"
import style0 from "./AudioBar.vue?vue&type=style&index=0&id=c85a507c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports